import styled from 'styled-components';
import { Form } from 'react-bootstrap';

const StyledInput = styled(Form.Control)`
  padding: 10px 14px;
  font-size: ${({ theme }) => theme?.fontSizeBase || '14px'};
  width: 100%;
  background-color: ${({ theme }) => theme.dark ? theme.selectBg : 'transparent'};
  border-radius: ${({ theme }) => theme?.radiusSm || '8px'};
  border: ${({ $borderWidth, isInvalid }) => $borderWidth ?? '1.5px '} solid
    ${({ theme, isInvalid }) => isInvalid ? theme.danger : theme.inputBorder};
  transition: border-color 0.15s ease, box-shadow 0.15s ease, background-color 0.15s ease;

  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.headingColor} !important;
  font-size: ${({ $fontSize }) => $fontSize ?? '14px'};
  font-weight: ${({ $fontWeight }) => $fontWeight ?? '400'};

  &:focus {
    box-shadow: 0 0 0 3px ${({ theme }) => theme?.dark ? 'rgba(220, 96, 30, 0.2)' : 'rgba(13, 35, 73, 0.12)'};
    color: ${({ theme }) => theme.inputColor};
    border-color: ${({ theme }) => theme?.dark ? theme.secondary : theme.primary};
    background-color: ${({ theme }) => theme.dark ? theme.selectBg : 'transparent'};
    outline: none;
  }

  &[type='textarea'] {
  &:focus {
    box-shadow: none;
    color: ${({ theme }) => theme.inputColor};
    border-color: ${({ theme }) => theme.primaryLight2} !important;
    background-color: ${({ theme }) => theme.dark ? theme.selectBg : 'transparent'};
  }
  
  }

  //add styles when input has value
  // &:not(:placeholder-shown)
  &:valid {
    background-image: none;
  }
  &::placeholder {
    color: ${({ theme }) => theme.inputPlaceHolder};
    font-size: ${({ $phFontSize }) => $phFontSize ?? '14px'};
    font-weight: ${({ $phFontWeight }) => $phFontWeight ?? '14px'};
    opacity: 1;
  }

  &.publicForms {
    color: ${({ theme }) => theme.headingColor || theme.primary} !important;
    -webkit-text-fill-color: ${({ theme }) =>
      theme.headingColor || theme.primary} !important;
    caret-color: ${({ theme }) => theme.headingColor || theme.primary};
    border: none;
    border-bottom: 1px solid ${({ theme }) => theme.inputBorder || theme.primary};
    border-radius: 0;
    background-color: transparent !important;
    &:focus {
      outline: none;
      border-bottom: 2px solid ${({ theme }) => theme.primary};
      color: ${({ theme }) => theme.headingColor || theme.primary} !important;
      -webkit-text-fill-color: ${({ theme }) =>
        theme.headingColor || theme.primary} !important;
    }
    &::placeholder {
    color: ${({ theme }) => theme.textColor || theme.primary};
    -webkit-text-fill-color: ${({ theme }) => theme.textColor || theme.primary};
    opacity: 0.8;
  }
  }

  &[type='range'] {
    height: 2px;
    border: none;
    outline: none;
    padding: 15px 0;

    &::-webkit-slider-runnable-track {
      width: 100%;
      height: 3px;
      cursor: pointer;
      animate: 0.2s;
      background: ${({ theme }) => theme.primary};
      border-radius: 3px;
    }

    &::-webkit-slider-thumb {
      border: 1px solid ${({ theme }) => theme.inputBorder};
      height: 20px;
      width: 20px;
      border-radius: 50%;
      background: ${({ theme }) => theme.white};
      cursor: pointer;
      -webkit-appearance: none;
      margin-top: -9px;
    }
  }
  :-webkit-autofill,
  :-webkit-autofill:hover,
  :-webkit-autofill:focus,
  :-webkit-autofill:active {
    transition: background-color 5000s ease-in-out 0s;
    -webkit-box-shadow: 0 0 0 30px ${({ theme }) => theme.dark? theme.darkLight : 'white'} inset !important;
  }
`;

export default StyledInput;
